class MegaMenu extends HTMLElement {
    constructor () {
        super();

        this.boundOpen = this.open.bind(this);
        this.boundCloseAll = this.closeMegaMenuAll.bind(this);

        this.mode = null;

        window.addEventListener('resize', this.init.bind(this));
        this.init();
    }

    init() {
        this.main_buttons = this.querySelectorAll('.childmenu .link-menu');
        this.grandchild_menu_list = this.querySelectorAll('.grandchild-menu');

        this.openFirstMenu();

        const supportsHover = window.matchMedia('(hover: hover)').matches;
        const isTouch = !supportsHover;

        const newMode = isTouch ? 'touch' : 'mouse';
        if (this.mode === newMode) return;
        this.mode = newMode;

        this.main_buttons.forEach(button => {
            button.removeEventListener('click', this.boundOpen);
            button.removeEventListener('mouseenter', this.boundOpen);
        });

        if (isTouch) {
            this.main_buttons.forEach(button => {
                button.addEventListener('click', this.boundOpen);
            });
        } else {
            this.main_buttons.forEach(button => {
                button.addEventListener('mouseenter', this.boundOpen);
            });
        }
    }
    openFirstMenu() {
        const firstElement = this.main_buttons[0];
        if (firstElement) {
          this.open(firstElement);
        }
    }
    open(e) {
        this.closeMegaMenuAll();
        const target = e instanceof Event ? e.target : e;
        const handle = target.dataset.handle;
        if (!handle) return;
        target.classList.add('active');
        const el = this.querySelector(`.grandchild-menu[data-handle="${handle}"]`);
        el?.classList.add('active');
    }
    closeMegaMenuAll() {
        this.main_buttons.forEach(button => {
                button.classList.remove('active');
            });
        this.grandchild_menu_list.forEach(menu => {
            menu.classList.remove('active');
        });
    }
}
customElements.define('mega-menu', MegaMenu);



class Menu extends HTMLElement {
    constructor() {
        super();

        this.boundToggle = this.toggle.bind(this);
        this.boundCloseAll = this.closeMegaMenuAll.bind(this);

        this.mode = null;

        window.addEventListener('resize', this.init.bind(this));
        this.init();
    }

    init() {
        this.main_buttons = this.querySelectorAll('.main-menu .link-menu');
        this.mega_menu_list = this.querySelectorAll('.mega-menu');

        const supportsHover = window.matchMedia('(hover: hover)').matches;
        const isTouch = !supportsHover;

        const newMode = isTouch ? 'touch' : 'mouse';
        if (this.mode === newMode) return;
        this.mode = newMode;

        this.main_buttons.forEach(button => {
            button.removeEventListener('click', this.boundToggle);
            button.removeEventListener('mouseenter', this.boundToggle);
        });
        this.removeEventListener('mouseleave', this.boundCloseAll);

        if (isTouch) {
            this.main_buttons.forEach(button => {
                button.addEventListener('click', this.boundToggle);
            });
        } else {
            this.main_buttons.forEach(button => {
                button.addEventListener('mouseenter', this.boundToggle);
            });
            this.addEventListener('mouseleave', this.boundCloseAll);
        }
        document.addEventListener('click', (event) => {
            const targetElement = this; 
            if (targetElement && !targetElement.contains(event.target)) {
               this.closeMegaMenuAll();
            }
        });
    }

    toggle(e) {
        const handle = e.target.dataset.handle;
        if (!handle) {
            this.closeMegaMenuAll();
            return;
        }
        const el = this.querySelector(`.mega-menu[data-handle="${handle}"]`);
        const active_el = el.classList.contains('active');
        if(!active_el) this.closeMegaMenuAll();
        e.target.classList.add('active');
        el.classList.toggle('active');
    }


    closeMegaMenuAll() {
        this.main_buttons.forEach(button => {
            button.classList.remove('active');
        })
        
        this.mega_menu_list.forEach(menu => {
            menu.classList.remove('active');
        });
    }
}

customElements.define('custom-menu', Menu);
